<template>
    <b-row>
        <div class="table-responsive" style="margin: 0 5px;">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em; border-top: none !important;">
                <thead class="borderless" style="text-align: center;">
                    <th colspan="4">{{ $t('intensityTableTitle') }}</th>
                </thead>
                <thead style="text-align: center">
                <tr>
                    <th style="text-align: left; width: 20em">{{ $t('measurement') }}</th>
                    <th style="text-align: right">{{this.year - 1}}</th>
                    <th style="text-align: right">{{this.year}}</th>
                    <th>{{ $t('changingColumn') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style="text-align: left">{{ $t('IntensityTotalEmissions') }}</td>
                    <td style="text-align: right">{{intensityReport.pastEmission | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">{{intensityReport.currentEmission | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">
                        <b-row no-gutters align-h="between" v-if="calculateRatio(intensityReport.pastEmission, intensityReport.currentEmission) !== '0.0'">
                            <b-col cols="6">
                                <b-row no-gutters>
                                    <b-col cols="11" style="text-align: right">
                                        <img v-if="calculateRatio(intensityReport.pastEmission, intensityReport.currentEmission) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                        <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="6" style="text-align: left">
                                {{ calculateRatio(intensityReport.pastEmission, intensityReport.currentEmission) | absoluteNumber | parseNumber('float', locale) }}
                            </b-col>
                        </b-row>
                        <b-row no-gutters align-h="end" v-else>
                            <b-col cols="6" style="text-align: left">-</b-col>
                        </b-row>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left">{{ $t('IntensityTotalConsumption') }} ({{$store.state.analysis_unit}})</td>
                    <td style="text-align: right">{{intensityReport.pastConsumption | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">{{intensityReport.currentConsumption | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">
                        <b-row no-gutters align-h="between" v-if="calculateRatio(intensityReport.pastConsumption, intensityReport.currentConsumption) !== '0.00'">
                            <b-col cols="6">
                                <b-row no-gutters>
                                    <b-col cols="11" style="text-align: right">
                                        <img v-if="calculateRatio(intensityReport.pastConsumption, intensityReport.currentConsumption ) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                        <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="6" style="text-align: left">
                                {{ calculateRatio(intensityReport.pastConsumption, intensityReport.currentConsumption) | absoluteNumber | parseNumber('float', locale)}}
                            </b-col>
                        </b-row>
                        <b-row no-gutters align-h="end" v-else>
                            <b-col cols="6" style="text-align: left">-</b-col>
                        </b-row>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left">{{ $t('IntensityTotalEmployeeCount') }}</td>
                    <td style="text-align: right">{{intensityReport.pastStaffCount | parseNumber('number', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">{{intensityReport.currentStaffCount | parseNumber('number', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">
                        <b-row no-gutters align-h="between" v-if="calculateRatio(intensityReport.pastStaffCount, intensityReport.currentStaffCount) !== '0.00'">
                            <b-col cols="6">
                                <b-row no-gutters>
                                    <b-col cols="11" style="text-align: right">
                                        <img v-if="calculateRatio(intensityReport.pastStaffCount, intensityReport.currentStaffCount) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                        <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="6" style="text-align: left">
                                {{ calculateRatio(intensityReport.pastStaffCount, intensityReport.currentStaffCount) | absoluteNumber | parseNumber('float', locale) }}
                            </b-col>
                        </b-row>
                        <b-row no-gutters align-h="end" v-else>
                            <b-col cols="6" style="text-align: left">-</b-col>
                        </b-row>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left">{{ $t('emissionValuePerEmployee') }}</td>
                    <td style="text-align: right">{{intensityReport.pastEmissionPerStaff | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">{{intensityReport.currentEmissionPerStaff | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">
                        <b-row no-gutters align-h="between" v-if="calculateRatio(intensityReport.pastEmissionPerStaff, intensityReport.currentEmissionPerStaff) !== '0.00'">
                            <b-col cols="6">
                                <b-row no-gutters>
                                    <b-col cols="11" style="text-align: right">
                                        <img v-if="calculateRatio(intensityReport.pastEmissionPerStaff, intensityReport.currentEmissionPerStaff) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                        <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="6" style="text-align: left">
                                {{ calculateRatio(intensityReport.pastEmissionPerStaff, intensityReport.currentEmissionPerStaff) | absoluteNumber | parseNumber('float', locale) }}
                            </b-col>
                        </b-row>
                        <b-row no-gutters align-h="end" v-else>
                            <b-col cols="6" style="text-align: left">-</b-col>
                        </b-row>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left">{{ $t('consumptionValuePerEmployee') }} ({{$store.state.analysis_unit}}/{{$t('person')}})</td>
                    <td style="text-align: right">{{intensityReport.pastConsumptionPerStaff | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">{{intensityReport.currentConsumptionPerStaff | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                    <td style="text-align: right">
                        <b-row no-gutters align-h="between" v-if="calculateRatio(intensityReport.pastConsumptionPerStaff, intensityReport.currentConsumptionPerStaff) !== '0.00'">
                            <b-col cols="6">
                                <b-row no-gutters>
                                    <b-col cols="11" style="text-align: right">
                                        <img v-if="calculateRatio(intensityReport.pastConsumptionPerStaff, intensityReport.currentConsumptionPerStaff) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                        <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="6" style="text-align: left">
                                {{ calculateRatio(intensityReport.pastConsumptionPerStaff, intensityReport.currentConsumptionPerStaff) | absoluteNumber | parseNumber('float', locale) }}
                            </b-col>
                        </b-row>
                        <b-row no-gutters align-h="end" v-else>
                            <b-col cols="6" style="text-align: left">-</b-col>
                        </b-row>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-row>
</template>

<script>
export default {
    name: 'IntensityMeasurementsOfEmission',
    props: {
        initialIntensityReport: {
            type: Object,
            default() {
                return {
                    currentConsumptions: [],
                    currentEmissions: [],
                    currentStaffs: [],
                    pastConsumptions: [],
                    pastEmissions: [],
                    pastStaffs: []
                };
            }
        },
        initialEmissions: {
            default() {
                return {
                    current: [],
                    past: []
                };
            }
        },
        selectedSiteId: {
            default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            intensityReport: {
                pastConsumptionPerStaff: 0,
                currentConsumptionPerStaff: 0,
                pastEmissionPerStaff: 0,
                currentEmissionPerStaff: 0,
                pastStaffCount: 0,
                currentStaffCount: 0,
                pastConsumption: 0,
                currentConsumption: 0,
                pastEmission: 0,
                currentEmission: 0
            }
        };
    },
    methods: {
        calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            let subtraction = currentValue - lastValue;
            let ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        aggregateIntensityReport({
            currentConsumptions,
            pastConsumptions,
            currentEmissions,
            pastEmissions,
            currentStaffs,
            pastStaffs
        }) {
            let currentEmission = Number(currentEmissions).toFixed(2);
            let pastEmission = Number(pastEmissions).toFixed(2);
            let currentConsumption = Number(currentConsumptions.toFixed(2));
            let pastConsumption = Number(pastConsumptions.toFixed(2));
            let currentStaffCount = Number(currentStaffs);
            let pastStaffCount = Number(pastStaffs);

            return Promise.resolve({
                currentEmission,
                pastEmission,
                currentConsumption,
                pastConsumption,
                currentEmissionPerStaff: currentStaffCount
                    ? Number((currentEmission / currentStaffCount).toFixed(2))
                    : 0,
                pastEmissionPerStaff: pastStaffCount
                    ? Number((pastEmission / pastStaffCount).toFixed(2))
                    : 0,
                currentConsumptionPerStaff: currentStaffCount
                    ? Number((currentConsumption / currentStaffCount).toFixed(2))
                    : 0,
                pastConsumptionPerStaff: pastStaffCount
                    ? Number((pastConsumption / pastStaffCount).toFixed(2))
                    : 0,
                currentStaffCount,
                pastStaffCount
            });
        },
        processReport(data) {
            this.aggregateIntensityReport(data).then(result => {
                this.intensityReport = result;
            });
        }
    },
    watch: {
        initialIntensityReport(data) {
            this.processReport(data);
        },
        selectedSiteId() {
            this.processReport(this.initialIntensityReport);
        },
        selectedSiteGroupId() {
            this.processReport(this.initialIntensityReport);
        }
    },
    mounted() {
        this.processReport(this.initialIntensityReport);
    }
};
</script>

<style scoped lang="scss">
.borderless {
    th {
        border-top: none;
        font-size: 1.2em;
    }
}
</style>
<i18n src="../../../../i18n/common.json"></i18n>
<i18n>
    {
        "tr": {
            "intensityTableTitle": "Emisyon Yoğunluk Ölçümleri",
            "measurement": "Ölçüm",
            "changingColumn": "Değişim (%)",
            "IntensityTotalEmissions": "Toplam Emisyon (tonCO2e)",
            "IntensityTotalConsumption": "Toplam Tüketim",
            "IntensityTotalEmployeeCount": "Toplam Kişi Sayısı",
            "emissionValuePerEmployee": "Kişi Başına Emisyon (tonCO2e/kişi)",
            "consumptionValuePerEmployee": "Kişi Başına Tüketim",
            "person": "kişi"
        },
        "en": {
            "intensityTableTitle": "Intensity Measurements of Emission",
            "measurement": "Measurement",
            "changingColumn": "Change (%)",
            "IntensityTotalEmissions": "Total Emissions (mtCO2e)",
            "IntensityTotalConsumption": "Total Consumption",
            "IntensityTotalEmployeeCount": "Number of People" ,
            "emissionValuePerEmployee": "Emissions per Person (mtCO2e/person)",
            "consumptionValuePerEmployee": "Consumption per Person",
            "person": "person"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Analysis/Tabs/components/IntensityMeasurementsOfEmission.vue